import { isActionWhitelisted } from 'layout/widgets/adaChat/actionPermissions'
import {
  isInDesignTab,
  validateActionRequirementsOrThrow,
} from 'layout/widgets/adaChat/utils/validateActionRequirements'
import { loadInverterDesignAssistantResult } from 'layout/widgets/adaChat/utils/loadInverterDesignAssistantResult'
import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'

interface LoadInverterDesignAssistantResultArgs {
  inverterSetIndex: number
  confirmed?: boolean
}

export const TOOL_NAME = 'load_inverter_design_assistant_result'

export async function LoadInverterDesignAssistantResultToolCall(
  functionCall: LiveFunctionCall,
  history: any,
  orgId: number | undefined
) {
  const args = functionCall.args as LoadInverterDesignAssistantResultArgs

  console.log('[Voice] LoadInverterDesignAssistantResultToolCall', args)

  const pathname = window.location.pathname
  validateActionRequirementsOrThrow('loadInverterDesignAssistantResult', pathname)

  // Extract project ID from pathname
  const { projectId } = isInDesignTab(pathname)

  if (!projectId) {
    throw new Error('Project ID is required to load inverter recommendations')
  }

  // Check if this action requires confirmation (it doesn't, but check anyway)
  const isWhitelisted = isActionWhitelisted('loadInverterDesignAssistantResult')

  // Load the inverter recommendation
  try {
    await loadInverterDesignAssistantResult(args.inverterSetIndex)

    // Update the toolExecutionState to 'completed' if we can find the message
    if (window.reduxStore && projectId) {
      const state = window.reduxStore.getState()
      const messages = state?.chatDrawer?.messages || []

      let targetMessageIndex = -1
      for (let i = messages.length - 1; i >= 0; i--) {
        if (
          messages[i].direction === 'receive' &&
          messages[i].toolExecutionState &&
          messages[i].toolExecutionState.toolType === 'inverterDesignAssistant'
        ) {
          targetMessageIndex = i
          break
        }
      }

      if (targetMessageIndex >= 0) {
        const { chatDrawerActions } = await import('ducks/chatDrawer')
        window.reduxStore.dispatch(
          chatDrawerActions.updateToolExecutionState(targetMessageIndex, {
            toolType: 'inverterDesignAssistant',
            status: 'completed',
            projectId: projectId,
          })
        )
      }
    }

    return {
      success: true,
      message: `Inverter recommendation ${args.inverterSetIndex + 1} loaded successfully`,
    }
  } catch (error: any) {
    console.error('[Voice] Load inverter design assistant result error:', error)

    // Update the toolExecutionState to 'error' if we can find the message
    if (window.reduxStore && projectId) {
      const state = window.reduxStore.getState()
      const messages = state?.chatDrawer?.messages || []

      let targetMessageIndex = -1
      for (let i = messages.length - 1; i >= 0; i--) {
        if (
          messages[i].direction === 'receive' &&
          messages[i].toolExecutionState &&
          messages[i].toolExecutionState.toolType === 'inverterDesignAssistant'
        ) {
          targetMessageIndex = i
          break
        }
      }

      if (targetMessageIndex >= 0) {
        const { chatDrawerActions } = await import('ducks/chatDrawer')
        window.reduxStore.dispatch(
          chatDrawerActions.updateToolExecutionState(targetMessageIndex, {
            toolType: 'inverterDesignAssistant',
            status: 'error',
            projectId: projectId,
            description: error?.message || 'Failed to load inverter recommendations',
            error: {
              message: error?.message || 'Failed to load inverter recommendations',
            },
          })
        )
      }
    }

    throw error
  }
}

